import moment from "moment";
import formatMoney from '@jlozovei/format-money';

export default {
    data(){
        return{
            mostraErro: false,
            erroMensagem: "",
            search: "",
            isLoading: false,
            pagination: { rowsPerPage: 25 },
            footerprops: {
              'rows-per-page-text' : 'Linhas por Página'
            },
            textoTabela: "Não há dados a serem exibidos",
            lang: {
              days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
              months: [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dec"
              ],
              pickers: [
                "prox 7 dias",
                "prox 30 dias",
                "7 dias anteriores",
                "30 dias anteriores"
              ],
              placeholder: {
                date: "Selecione a data",
                dateRange: "Selecione o intervalo"
              }
            },
        };
    },
    methods : {
        alertaSucesso(msg){
            this.$swal.fire({
                position: "center",
                type: "success",
                title: msg,
                showConfirmButton: false,
                timer: 3500
            });
        },
        alertaErro(msg){
            this.$swal.fire({
                position: "center",
                type: "error",
                title: msg,
                showConfirmButton: true,
            });
        },
        alertaAtencao(msg){
            this.$swal.fire({
                position: "center",
                type: "warning",
                title: msg,
                showConfirmButton: true,
            });
        },
        padronizaData(data) {
            return data ? moment(String(data)).format("DD/MM/YYYY") : "";
        },
        padronizaDataHora(data) {
          return data ? moment(String(data)).format("DD/MM/YYYY HH:mm") : "";
        },
        padronizaHora(horario) {
          return moment.utc(horario).format("HH:mm")
        },
        padronizaDataHoraISO(data_hora){
          let dt = data_hora;
          let current_date = dt.getDate();
          let current_month = dt.getMonth() + 1;
          let current_year = dt.getFullYear();
          let current_hrs = dt.getHours();
          let current_mins = dt.getMinutes();
          let current_secs = dt.getSeconds();
          let current_datetime;

          current_date = current_date < 10 ? '0' + current_date : current_date;
          current_month = current_month < 10 ? '0' + current_month : current_month;
          current_hrs = current_hrs < 10 ? '0' + current_hrs : current_hrs;
          current_mins = current_mins < 10 ? '0' + current_mins : current_mins;
          current_secs = current_secs < 10 ? '0' + current_secs : current_secs;

          current_datetime = current_year + '-' + current_month + '-' + current_date + 'T' + current_hrs + ':' + current_mins + ':' + current_secs;
          return current_datetime;
        },
        padronizaValor(valor) {
            return (formatMoney({
              value: valor,
              currencyCode: 'BRL',
              locale: 'pt-BR'
            }))
        },
        fechaAlert(state){
            this.mostraErro = state;
        },
        numberToReal(numero) {
            let num = parseFloat(numero).toFixed(2).split('.');
            num[0] = "R$ " + num[0].split(/(?=(?:...)*$)/).join('.');
            num[0] = num[0].replace('-.','-')
            return num.join(',');
        },
        soma(array, param){
            let total = 0;
            array.map(obj => {
                total += parseFloat(obj[param])
            })
            return total;   
        },
        media(array, param){
            let total = 0;
            array.map(obj => {
                total += parseFloat(obj[param])
            })
            return (total/array.length); 
        },
        sort(array, type){
            let loop;
            let n = array.length - 1;
            let x = array;
            if(type == 'decrescente'){
                do{
                    loop = false;
                    for(let i = 0; i < n; i++){
                      if(x[i].data < x[i + 1].data){
                        let temp = x[i]
                        x[i] = x[i + 1]
                        x[i + 1] = temp
                       
                        loop = true
                      }
                    }
                    n--;
                  }while(loop)
            }else{
                do{
                    loop = false;
                    for(let i = 0; i < n; i++){
                      if(x[i].data > x[i + 1].data){
                        let temp = x[i]
                        x[i] = x[i + 1]
                        x[i + 1] = temp
                       
                        loop = true
                      }
                    }
                    n--;
                  }while(loop)
            }
            
            return x
          },
          date_to_timestemp(data){
            return data.split('/')[2]+'-'+data.split('/')[1]+'-'+data.split('/')[0]
          },
          padronizaCep(cep) {
            return (cep.substring(0,cep.length-3) + '-' + cep.substring(cep.length-3));
          },
          pontoEmVirgula(data){
            return (data) ? data.replace('.',',') : data;
          },
          virgulaEmPonto(data){
            return (data) ? data.replace(',','.') : data;
          },
          capitalize(s){
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
          },
          negativeNumbers(number){
              if(number < 0){
                  return 'negative-values'
              }else{
                  return
              }
          },

     return_mes(mesNumero) {
      let meses = {
        "01": "Janeiro",
        "02": "Fevereiro",
        "03": "Março",
        "04": "Abril",
        "05": "Maio",
        "06": "Junho",
        "07": "Julho",
        "08": "Agosto",
        "09": "Setembro",
        "10": "Outubro",
        "11": "Novembro",
        "12": "Dezembro"
      };
      return meses[mesNumero];
    },
    retornaStatus(idStatus, arrayStatus) {

      let idStatusDesejado = arrayStatus.findIndex(
        x => x.id == idStatus
      );
      return arrayStatus[idStatusDesejado].nome;
    },
    removeDups(names) {
        let unique = {};
        names.forEach(function(i) {
          if(!unique[i]) {
            unique[i] = true;
          }
        });
        return Object.keys(unique);
      },
    elimina_iguais(array){
        let items = [];
        array.map(obj => {
            items.push(obj.conta_corrente)
        })
        return this.removeDups(items)
    },
       
    scrollToTop() {
        window.scrollTo(0, 0);
    }
    
    }
}